<script>
    import { _ } from "svelte-i18n"
    import { spaLink } from "../../functionTools/routing"
    import { lang } from "../../store"
    import Index from "../SEO/Index.svelte"

    // set 404 for ssr
    if (typeof window === "undefined") {
        // @ts-ignore
        if (context) context.is404 = true
    }
</script>

<Index title={$_("general.not-found")} metaDescription={$_("general.not-found")} noIndex={true} />
<div class="not-found">
    <div class="content">
        <h1>404</h1>
        <h2>{$_("general.not-found")}</h2>
        <p></p>
        <a href="/{$lang}" use:spaLink class="back-home">{$_("general.back")}</a>
    </div>
</div>

<style lang="less">
    .not-found {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;

        .content {
            text-align: center;
            padding: 2rem;
            background-color: rgba(255, 255, 255, 0.9);

            h1 {
                font-size: 6rem;
                margin-bottom: 2rem;
            }

            h2 {
                font-size: 2rem;
                margin-bottom: 1rem;
            }

            p {
                margin-bottom: 2rem;
            }

            .back-home {
                text-decoration: none;
                border: 1px solid black;
                padding: 0.5rem 1rem;
                transition:
                    background-color 0.2s,
                    color 0.2s;
            }
        }
    }
</style>
